import { Outlet, useNavigate } from 'react-router-dom'
import { useLoginContext } from '../../Contexts/LoginContext';
import { useEffect } from 'react';
import { useStoreHook } from '../../Hooks/StoreHook';

export default function Profile() {

    const { user } = useLoginContext();
    const { getLinkToHome } = useStoreHook();

    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate(getLinkToHome());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!user) return null;
    return (
        <main>
            <Outlet />
        </main>
    )
};